/**
 * interiorMoodboards — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {LANDSCAPE, tagline, chips, type ToilePack} from './data'

export const interiorMoodboardsPack: ToilePack = {
    slug: 'interior-moodboards',
    category: 'interior',
    name: 'Interior moodboards',
    tagline: tagline('renders', 'rooms', 'styles'),
    chips: chips('rooms', 'styles'),
    ratio: LANDSCAPE,
    readings: [
        {key: 'bedroom', label: 'Bedroom', subject: 'a small bedroom with a low bed and a reading nook'},
        {key: 'kitchen', label: 'Kitchen', subject: 'a galley kitchen with open shelves and a breakfast bar'},
        {key: 'studio', label: 'Studio corner', subject: 'a home-office corner in a studio apartment'},
    ],
    styles: [
        {key: 'japandi', label: 'Japandi', style: 'japandi style, wabi-sabi ceramics', palette: 'pale oak, linen, black accents', framing: 'eye-level, daylight from a window'},
        {key: 'maximal', label: 'Maximalist', style: 'maximalist style, gallery wall', palette: 'jewel tones, layered textiles', framing: 'eye-level, daylight from a window'},
        {key: 'midcentury', label: 'Mid-century', style: 'mid-century modern style, tapered legs', palette: 'walnut, mustard and teal', framing: 'eye-level, daylight from a window'},
    ],
    directions: ['for a nursery instead', 'in darker, moodier tones', 'for a smaller space'],
}
